import React from 'react'
import { Link } from 'react-router-dom'

const Banner = () => {
    return (
        <>
            <div className="banner-section-four">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-8 col-xl-10">
                            <div
                                className="banner-left-four animate fadeInRightBig wow"
                                data-wow-duration="2500ms"
                            >
                                <div className="banner-heading-box-four">
                                    <h1>We Built trust in our customers mind</h1>
                                </div>
                                <Link to="/Contact" className="btn btn-light btn-theme">
                                    Contact Us <span>+</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Banner
